<template>
  <UiEditableListBase v-bind="{ ...$props, ...$attrs }">
    <template
      v-if="$slots.item"
      #item="slotProps">
      <slot
        name="item"
        v-bind="slotProps" />
    </template>
  </UiEditableListBase>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { IEditableListOption } from '@team-milva/lab-components'
import { t } from '@/locales'

export default {
  name: 'UiEditableList',
  inheritAttrs: false,
  props: {
    items: { type: Array as PropType<unknown[]>, required: true as const },
    itemKey: {
      type: [String, Function] as PropType<string | ((item: unknown, index: number) => string)>,
      default: undefined,
    },
    isDraggable: { type: Boolean, default: undefined },
    isRemovable: { type: Boolean, default: undefined },
    isCatalog: { type: Boolean, default: undefined },
    compact: { type: Boolean, default: undefined },
    emptyStateText: { type: String, default: undefined },
    addOptions: {
      type: Array as PropType<IEditableListOption[]>,
      default: undefined,
    },
    addPlaceholder: { type: String, default: () => t('W: Vælg...') },
    addSearchPlaceholder: { type: String, default: () => t('W: Søg...') },
    addEmptyText: { type: String, default: () => t('W: Ingen resultater') },
    createNewLabel: { type: String, default: undefined },
  },
}
</script>
